/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../public/upgrade/shared/sara-selector/sara-selector.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../node_modules/@angular/forms/src/directives/checkbox_value_accessor.ngfactory';
import * as import10 from '../../../../node_modules/@angular/forms/src/directives/ng_model.ngfactory';
import * as import11 from '../../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import12 from '@angular/core/src/linker/view_container';
import * as import13 from '@angular/core/src/linker/element_ref';
import * as import14 from '@angular/forms/src/directives/checkbox_value_accessor';
import * as import15 from '@angular/forms/src/directives/control_value_accessor';
import * as import16 from '@angular/forms/src/directives/ng_model';
import * as import17 from '@angular/forms/src/directives/ng_control';
import * as import18 from '@angular/forms/src/directives/ng_control_status';
import * as import19 from '../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import20 from '@angular/core/src/linker/template_ref';
import * as import21 from '@angular/common/src/directives/ng_if';
import * as import22 from '../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import23 from '../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import24 from '@ngx-translate/core/src/translate.pipe';
import * as import25 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import26 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import27 from '@ngx-translate/core/src/translate.service';
import * as import28 from '@angular/common/src/directives/ng_for';
import * as import29 from '@angular/common/src/directives/ng_class';
export class Wrapper_SaraSelectorComponent {
  /*private*/ _eventHandler:Function;
  context:import0.SaraSelectorComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  /*private*/ _expr_3:any;
  /*private*/ _expr_4:any;
  /*private*/ _expr_5:any;
  constructor() {
    this._changed = false;
    this.context = new import0.SaraSelectorComponent();
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
    this._expr_3 = import1.UNINITIALIZED;
    this._expr_4 = import1.UNINITIALIZED;
    this._expr_5 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  check_error(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.error = currValue;
      this._expr_0 = currValue;
    }
  }
  check_name(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.name = currValue;
      this._expr_1 = currValue;
    }
  }
  check_config(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this._changed = true;
      this.context.config = currValue;
      this._expr_2 = currValue;
    }
  }
  check_items(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_3,currValue))) {
      this._changed = true;
      this.context.items = currValue;
      this._expr_3 = currValue;
    }
  }
  check_validations(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_4,currValue))) {
      this._changed = true;
      this.context.validations = currValue;
      this._expr_4 = currValue;
    }
  }
  check_editable(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_5,currValue))) {
      this._changed = true;
      this.context.editable = currValue;
      this._expr_5 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_SaraSelectorComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_SaraSelectorComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.SaraSelectorComponent>;
  _SaraSelectorComponent_0_3:Wrapper_SaraSelectorComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_SaraSelectorComponent_Host0,renderType_SaraSelectorComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'sara-selector',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_SaraSelectorComponent0(this.viewUtils,this,0,this._el_0);
    this._SaraSelectorComponent_0_3 = new Wrapper_SaraSelectorComponent();
    this.compView_0.create(this._SaraSelectorComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._SaraSelectorComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.SaraSelectorComponent) && (0 === requestNodeIndex))) { return this._SaraSelectorComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._SaraSelectorComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const SaraSelectorComponentNgFactory:import8.ComponentFactory<import0.SaraSelectorComponent> = new import8.ComponentFactory<import0.SaraSelectorComponent>('sara-selector',View_SaraSelectorComponent_Host0,import0.SaraSelectorComponent);
const styles_SaraSelectorComponent:any[] = ([] as any[]);
class View_SaraSelectorComponent1 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _CheckboxControlValueAccessor_4_3:import9.Wrapper_CheckboxControlValueAccessor;
  _NG_VALUE_ACCESSOR_4_4:any[];
  _NgModel_4_5:import10.Wrapper_NgModel;
  _NgControl_4_6:any;
  _NgControlStatus_4_7:import11.Wrapper_NgControlStatus;
  _el_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _text_9:any;
  /*private*/ _expr_15:any;
  /*private*/ _expr_16:any;
  /*private*/ _expr_17:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_SaraSelectorComponent1,renderType_SaraSelectorComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_15 = import1.UNINITIALIZED;
    this._expr_16 = import1.UNINITIALIZED;
    this._expr_17 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'li',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','eva-checkbox -sm'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'input',new import3.InlineArray2(2,'type','checkbox'),(null as any));
    this._CheckboxControlValueAccessor_4_3 = new import9.Wrapper_CheckboxControlValueAccessor(this.renderer,new import13.ElementRef(this._el_4));
    this._NG_VALUE_ACCESSOR_4_4 = [this._CheckboxControlValueAccessor_4_3.context];
    this._NgModel_4_5 = new import10.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_4_4);
    this._NgControl_4_6 = this._NgModel_4_5.context;
    this._NgControlStatus_4_7 = new import11.Wrapper_NgControlStatus(this._NgControl_4_6);
    this._el_5 = import3.createRenderElement(this.renderer,this._el_2,'i',new import3.InlineArray2(2,'class','checkbox-check fa fa-check'),(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_2,'em',new import3.InlineArray4(4,'class','capitalized','style','font-style: normal'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'',(null as any));
    this._text_8 = this.renderer.createText(this._el_2,'\n                                    ',(null as any));
    this._text_9 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_0));
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_4,new import3.InlineArray8(6,'ngModelChange',(null as any),'change',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_4));
    this._NgModel_4_5.subscribe(this,this.eventHandler(this.handleEvent_4),true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._el_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._text_9
    ]
    ),[
      disposable_0,
      disposable_1
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import14.CheckboxControlValueAccessor) && (4 === requestNodeIndex))) { return this._CheckboxControlValueAccessor_4_3.context; }
    if (((token === import15.NG_VALUE_ACCESSOR) && (4 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_4_4; }
    if (((token === import16.NgModel) && (4 === requestNodeIndex))) { return this._NgModel_4_5.context; }
    if (((token === import17.NgControl) && (4 === requestNodeIndex))) { return this._NgControl_4_6; }
    if (((token === import18.NgControlStatus) && (4 === requestNodeIndex))) { return this._NgControlStatus_4_7.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._CheckboxControlValueAccessor_4_3.ngDoCheck(this,this._el_4,throwOnChange);
    const currVal_4_1_0:any = this.parentView.context.items[this.context.$implicit.oid].checked;
    this._NgModel_4_5.check_model(currVal_4_1_0,throwOnChange,false);
    this._NgModel_4_5.ngDoCheck(this,this._el_4,throwOnChange);
    this._NgControlStatus_4_7.ngDoCheck(this,this._el_4,throwOnChange);
    const currVal_15:any = import3.inlineInterpolate(1,'list-group-item list-row ',(this.parentView.context.items[this.context.$implicit.oid].checked? 'selected-item': ''),'');
    if (import3.checkBinding(throwOnChange,this._expr_15,currVal_15)) {
      this.renderer.setElementProperty(this._el_0,'className',currVal_15);
      this._expr_15 = currVal_15;
    }
    const currVal_16:any = import3.inlineInterpolate(1,'',this.context.$implicit.oid,'');
    if (import3.checkBinding(throwOnChange,this._expr_16,currVal_16)) {
      this.renderer.setElementProperty(this._el_4,'value',currVal_16);
      this._expr_16 = currVal_16;
    }
    this._NgControlStatus_4_7.checkHost(this,this,this._el_4,throwOnChange);
    const currVal_17:any = import3.inlineInterpolate(1,'',this.context.$implicit.name,'');
    if (import3.checkBinding(throwOnChange,this._expr_17,currVal_17)) {
      this.renderer.setText(this._text_7,currVal_17);
      this._expr_17 = currVal_17;
    }
  }
  destroyInternal():void {
    this._NgModel_4_5.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.toggleItem(this.context.$implicit.oid)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_4(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._CheckboxControlValueAccessor_4_3.handleEvent(eventName,$event) && result);
    if ((eventName == 'ngModelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.items[this.context.$implicit.oid].checked = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_SaraSelectorComponent3 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _text_9:any;
  /*private*/ _expr_10:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_SaraSelectorComponent3,renderType_SaraSelectorComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_10 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','capitalized eva-label -primary text-right'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'a',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                    ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'span',new import3.InlineArray2(2,'style','color:white;padding:5px;'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                                        ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'i',new import3.InlineArray8(6,'aria-hidden','true','class','fa fa-times','style','margin:0'),(null as any));
    this._text_7 = this.renderer.createText(this._el_4,'\n                                    ',(null as any));
    this._text_8 = this.renderer.createText(this._el_2,'\n                                ',(null as any));
    this._text_9 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_2));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._text_9
    ]
    ),[disposable_0]);
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_10:any = import3.inlineInterpolate(1,'\n                                ',this.parentView.parentView.context.items[this.parentView.context.$implicit].name,'\n                                ');
    if (import3.checkBinding(throwOnChange,this._expr_10,currVal_10)) {
      this.renderer.setText(this._text_1,currVal_10);
      this._expr_10 = currVal_10;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.parentView.context.toggleItem(this.parentView.context.$implicit)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_SaraSelectorComponent2 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import12.ViewContainer;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import19.Wrapper_NgIf;
  _text_3:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_SaraSelectorComponent2,renderType_SaraSelectorComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray4(4,'class','top10','style','float: left;'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import12.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import20.TemplateRef_(this,2,this._anchor_2);
    this._NgIf_2_6 = new import19.Wrapper_NgIf(this._vc_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import20.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import21.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.context.items[this.context.$implicit].checked;
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 2)) { return new View_SaraSelectorComponent3(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    return (null as any);
  }
}
var renderType_SaraSelectorComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_SaraSelectorComponent,{});
export class View_SaraSelectorComponent0 extends import2.AppView<import0.SaraSelectorComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _text_25:any;
  _el_26:any;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _el_30:any;
  _text_31:any;
  _anchor_32:any;
  /*private*/ _vc_32:import12.ViewContainer;
  _TemplateRef_32_5:any;
  _NgFor_32_6:import22.Wrapper_NgFor;
  _text_33:any;
  _text_34:any;
  _text_35:any;
  _text_36:any;
  _text_37:any;
  _el_38:any;
  _text_39:any;
  _el_40:any;
  _text_41:any;
  _el_42:any;
  _text_43:any;
  _el_44:any;
  _text_45:any;
  _text_46:any;
  _text_47:any;
  _el_48:any;
  _text_49:any;
  _el_50:any;
  _text_51:any;
  _el_52:any;
  _text_53:any;
  _text_54:any;
  _text_55:any;
  _text_56:any;
  _text_57:any;
  _el_58:any;
  _text_59:any;
  _el_60:any;
  _NgClass_60_3:import23.Wrapper_NgClass;
  _text_61:any;
  _anchor_62:any;
  /*private*/ _vc_62:import12.ViewContainer;
  _TemplateRef_62_5:any;
  _NgFor_62_6:import22.Wrapper_NgFor;
  _text_63:any;
  _text_64:any;
  _el_65:any;
  _text_66:any;
  _text_67:any;
  _text_68:any;
  _text_69:any;
  _text_70:any;
  _text_71:any;
  _text_72:any;
  /*private*/ _expr_80:any;
  _pipe_translate_0:import24.TranslatePipe;
  /*private*/ _expr_82:any;
  _pipe_translate_1:import24.TranslatePipe;
  /*private*/ _expr_84:any;
  _pipe_translate_2:import24.TranslatePipe;
  /*private*/ _expr_86:any;
  _pipe_translate_3:import24.TranslatePipe;
  /*private*/ _expr_88:any;
  _pipe_translate_4:import24.TranslatePipe;
  /*private*/ _expr_90:any;
  /*private*/ _expr_91:any;
  _pipe_translate_5:import24.TranslatePipe;
  /*private*/ _expr_93:any;
  _map_94:any;
  /*private*/ _expr_95:any;
  _pipe_translate_6:import24.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_SaraSelectorComponent0,renderType_SaraSelectorComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_80 = import1.UNINITIALIZED;
    this._expr_82 = import1.UNINITIALIZED;
    this._expr_84 = import1.UNINITIALIZED;
    this._expr_86 = import1.UNINITIALIZED;
    this._expr_88 = import1.UNINITIALIZED;
    this._expr_90 = import1.UNINITIALIZED;
    this._expr_91 = import1.UNINITIALIZED;
    this._expr_93 = import1.UNINITIALIZED;
    this._map_94 = import3.pureProxy3((p0:any,p1:any,p2:any):{[key: string]:any} => {
      return {
        'panel-not-empty': p0,
        'panel-empty': p1,
        'input-error-noshadow': p2
      }
      ;
    });
    this._expr_95 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-row'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','panel-style'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','-lg-6 -md-6 -sm-12 -eva-3-mb-sm'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','eva-row general-operation-row'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','-sm-6 label-style'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'',(null as any));
    this._text_12 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','-sm-6 text-right'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'\n                        ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_13,'span',new import3.InlineArray2(2,'class','selection-panel-operatios-base label-color'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_15,'a',new import3.InlineArray2(2,'class','selection-panel-operatios-base action-color'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'',(null as any));
    this._text_19 = this.renderer.createText(this._el_15,'| ',(null as any));
    this._el_20 = import3.createRenderElement(this.renderer,this._el_15,'a',new import3.InlineArray2(2,'class','selection-panel-operatios-base action-color'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'',(null as any));
    this._text_22 = this.renderer.createText(this._el_15,'\n                        ',(null as any));
    this._text_23 = this.renderer.createText(this._el_13,'\n                    ',(null as any));
    this._text_24 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._text_25 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_26 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','eva-row'),(null as any));
    this._text_27 = this.renderer.createText(this._el_26,'\n                    ',(null as any));
    this._el_28 = import3.createRenderElement(this.renderer,this._el_26,'div',new import3.InlineArray2(2,'class','selection-panel-box scroll-y right10'),(null as any));
    this._text_29 = this.renderer.createText(this._el_28,'\n                        ',(null as any));
    this._el_30 = import3.createRenderElement(this.renderer,this._el_28,'ul',new import3.InlineArray2(2,'class','list-group'),(null as any));
    this._text_31 = this.renderer.createText(this._el_30,'\n                            ',(null as any));
    this._anchor_32 = this.renderer.createTemplateAnchor(this._el_30,(null as any));
    this._vc_32 = new import12.ViewContainer(32,30,this,this._anchor_32);
    this._TemplateRef_32_5 = new import20.TemplateRef_(this,32,this._anchor_32);
    this._NgFor_32_6 = new import22.Wrapper_NgFor(this._vc_32.vcRef,this._TemplateRef_32_5,this.parentView.injectorGet(import25.IterableDiffers,this.parentIndex),this.ref);
    this._text_33 = this.renderer.createText(this._el_30,'\n                        ',(null as any));
    this._text_34 = this.renderer.createText(this._el_28,'\n                    ',(null as any));
    this._text_35 = this.renderer.createText(this._el_26,'\n                ',(null as any));
    this._text_36 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_37 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_38 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','-lg-6 -md-6 -sm-12 -eva-3-mb-sm'),(null as any));
    this._text_39 = this.renderer.createText(this._el_38,'\n                ',(null as any));
    this._el_40 = import3.createRenderElement(this.renderer,this._el_38,'div',new import3.InlineArray2(2,'class','row general-operation-row'),(null as any));
    this._text_41 = this.renderer.createText(this._el_40,'\n                    ',(null as any));
    this._el_42 = import3.createRenderElement(this.renderer,this._el_40,'div',new import3.InlineArray2(2,'class','-sm-6 label-style pleft10'),(null as any));
    this._text_43 = this.renderer.createText(this._el_42,'\n                        ',(null as any));
    this._el_44 = import3.createRenderElement(this.renderer,this._el_42,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_45 = this.renderer.createText(this._el_44,'',(null as any));
    this._text_46 = this.renderer.createText(this._el_42,'\n                    ',(null as any));
    this._text_47 = this.renderer.createText(this._el_40,'\n                    ',(null as any));
    this._el_48 = import3.createRenderElement(this.renderer,this._el_40,'div',new import3.InlineArray2(2,'class','-sm-6 text-right pright0'),(null as any));
    this._text_49 = this.renderer.createText(this._el_48,'\n                        ',(null as any));
    this._el_50 = import3.createRenderElement(this.renderer,this._el_48,'span',new import3.InlineArray2(2,'class','selection-panel-operatios-base label-color'),(null as any));
    this._text_51 = this.renderer.createText(this._el_50,'\n                            ',(null as any));
    this._el_52 = import3.createRenderElement(this.renderer,this._el_50,'a',new import3.InlineArray2(2,'class','selection-panel-operatios-base action-color'),(null as any));
    this._text_53 = this.renderer.createText(this._el_52,'',(null as any));
    this._text_54 = this.renderer.createText(this._el_50,'\n                        ',(null as any));
    this._text_55 = this.renderer.createText(this._el_48,'\n                    ',(null as any));
    this._text_56 = this.renderer.createText(this._el_40,'\n                ',(null as any));
    this._text_57 = this.renderer.createText(this._el_38,'\n                ',(null as any));
    this._el_58 = import3.createRenderElement(this.renderer,this._el_38,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_59 = this.renderer.createText(this._el_58,'\n                    ',(null as any));
    this._el_60 = import3.createRenderElement(this.renderer,this._el_58,'div',new import3.InlineArray2(2,'class','selection-panel-box scroll-y'),(null as any));
    this._NgClass_60_3 = new import23.Wrapper_NgClass(this.parentView.injectorGet(import25.IterableDiffers,this.parentIndex),this.parentView.injectorGet(import26.KeyValueDiffers,this.parentIndex),new import13.ElementRef(this._el_60),this.renderer);
    this._text_61 = this.renderer.createText(this._el_60,'\n                        ',(null as any));
    this._anchor_62 = this.renderer.createTemplateAnchor(this._el_60,(null as any));
    this._vc_62 = new import12.ViewContainer(62,60,this,this._anchor_62);
    this._TemplateRef_62_5 = new import20.TemplateRef_(this,62,this._anchor_62);
    this._NgFor_62_6 = new import22.Wrapper_NgFor(this._vc_62.vcRef,this._TemplateRef_62_5,this.parentView.injectorGet(import25.IterableDiffers,this.parentIndex),this.ref);
    this._text_63 = this.renderer.createText(this._el_60,'\n                    ',(null as any));
    this._text_64 = this.renderer.createText(this._el_58,'\n                    ',(null as any));
    this._el_65 = import3.createRenderElement(this.renderer,this._el_58,'span',new import3.InlineArray2(2,'class','validation-msg'),(null as any));
    this._text_66 = this.renderer.createText(this._el_65,'',(null as any));
    this._text_67 = this.renderer.createText(this._el_58,'\n                ',(null as any));
    this._text_68 = this.renderer.createText(this._el_38,'\n            ',(null as any));
    this._text_69 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_70 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_71 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_72 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._pipe_translate_0 = new import24.TranslatePipe(this.parentView.injectorGet(import27.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import24.TranslatePipe(this.parentView.injectorGet(import27.TranslateService,this.parentIndex),this.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_17,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_17));
    this._pipe_translate_2 = new import24.TranslatePipe(this.parentView.injectorGet(import27.TranslateService,this.parentIndex),this.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_20,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_20));
    this._pipe_translate_3 = new import24.TranslatePipe(this.parentView.injectorGet(import27.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_4 = new import24.TranslatePipe(this.parentView.injectorGet(import27.TranslateService,this.parentIndex),this.ref);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_52,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_52));
    this._pipe_translate_5 = new import24.TranslatePipe(this.parentView.injectorGet(import27.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_6 = new import24.TranslatePipe(this.parentView.injectorGet(import27.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._text_22,
      this._text_23,
      this._text_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._el_30,
      this._text_31,
      this._anchor_32,
      this._text_33,
      this._text_34,
      this._text_35,
      this._text_36,
      this._text_37,
      this._el_38,
      this._text_39,
      this._el_40,
      this._text_41,
      this._el_42,
      this._text_43,
      this._el_44,
      this._text_45,
      this._text_46,
      this._text_47,
      this._el_48,
      this._text_49,
      this._el_50,
      this._text_51,
      this._el_52,
      this._text_53,
      this._text_54,
      this._text_55,
      this._text_56,
      this._text_57,
      this._el_58,
      this._text_59,
      this._el_60,
      this._text_61,
      this._anchor_62,
      this._text_63,
      this._text_64,
      this._el_65,
      this._text_66,
      this._text_67,
      this._text_68,
      this._text_69,
      this._text_70,
      this._text_71,
      this._text_72
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import20.TemplateRef) && (32 === requestNodeIndex))) { return this._TemplateRef_32_5; }
    if (((token === import28.NgFor) && (32 === requestNodeIndex))) { return this._NgFor_32_6.context; }
    if (((token === import20.TemplateRef) && (62 === requestNodeIndex))) { return this._TemplateRef_62_5; }
    if (((token === import28.NgFor) && (62 === requestNodeIndex))) { return this._NgFor_62_6.context; }
    if (((token === import29.NgClass) && ((60 <= requestNodeIndex) && (requestNodeIndex <= 63)))) { return this._NgClass_60_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_32_0_0:any = this.context.getItemsList();
    this._NgFor_32_6.check_ngForOf(currVal_32_0_0,throwOnChange,false);
    this._NgFor_32_6.ngDoCheck(this,this._anchor_32,throwOnChange);
    const currVal_60_0_0:any = 'selection-panel-box scroll-y';
    this._NgClass_60_3.check_klass(currVal_60_0_0,throwOnChange,false);
    const currVal_60_0_1:any = this._map_94(((this.context.validations == null)? (null as any): this.context.validations.hasAnySelected),!((this.context.validations == null)? (null as any): this.context.validations.hasAnySelected),this.context.error);
    this._NgClass_60_3.check_ngClass(currVal_60_0_1,throwOnChange,false);
    this._NgClass_60_3.ngDoCheck(this,this._el_60,throwOnChange);
    const currVal_62_0_0:any = this.context.getKeys(this.context.items);
    this._NgFor_62_6.check_ngForOf(currVal_62_0_0,throwOnChange,false);
    this._NgFor_62_6.ngDoCheck(this,this._anchor_62,throwOnChange);
    this._vc_32.detectChangesInNestedViews(throwOnChange);
    this._vc_62.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_80:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(((this.context.config == null)? (null as any): this.context.config.listOfItemsTitle))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_80,currVal_80))) {
      this.renderer.setText(this._text_11,currVal_80);
      this._expr_80 = currVal_80;
    }
    valUnwrapper.reset();
    const currVal_82:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('common.SELECT')),':');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_82,currVal_82))) {
      this.renderer.setText(this._text_16,currVal_82);
      this._expr_82 = currVal_82;
    }
    valUnwrapper.reset();
    const currVal_84:any = import3.inlineInterpolate(1,'\n										',valUnwrapper.unwrap(this._pipe_translate_2.transform('common.ALL')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_84,currVal_84))) {
      this.renderer.setText(this._text_18,currVal_84);
      this._expr_84 = currVal_84;
    }
    valUnwrapper.reset();
    const currVal_86:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('common.NONE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_86,currVal_86))) {
      this.renderer.setText(this._text_21,currVal_86);
      this._expr_86 = currVal_86;
    }
    valUnwrapper.reset();
    const currVal_88:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_4.transform(((this.context.config == null)? (null as any): this.context.config.listOfSelectedItemsTitle))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_88,currVal_88))) {
      this.renderer.setText(this._text_45,currVal_88);
      this._expr_88 = currVal_88;
    }
    const currVal_90:boolean = !((this.context.validations == null)? (null as any): this.context.validations.hasAnySelected);
    if (import3.checkBinding(throwOnChange,this._expr_90,currVal_90)) {
      this.renderer.setElementProperty(this._el_52,'hidden',currVal_90);
      this._expr_90 = currVal_90;
    }
    valUnwrapper.reset();
    const currVal_91:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_5.transform('common.DELETE_ALL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_91,currVal_91))) {
      this.renderer.setText(this._text_53,currVal_91);
      this._expr_91 = currVal_91;
    }
    const currVal_93:any = import3.inlineInterpolate(1,'eva-row eva-3-validation ',((this.context.error == null)? (null as any): this.context.error.cssClass),' -top-right');
    if (import3.checkBinding(throwOnChange,this._expr_93,currVal_93)) {
      this.renderer.setElementProperty(this._el_58,'className',currVal_93);
      this._expr_93 = currVal_93;
    }
    valUnwrapper.reset();
    const currVal_95:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_6.transform(((this.context.error == null)? (null as any): this.context.error.message))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_95,currVal_95))) {
      this.renderer.setText(this._text_66,currVal_95);
      this._expr_95 = currVal_95;
    }
  }
  destroyInternal():void {
    this._vc_32.destroyNestedViews();
    this._vc_62.destroyNestedViews();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 32)) { return new View_SaraSelectorComponent1(this.viewUtils,this,32,this._anchor_32,this._vc_32); }
    if ((nodeIndex == 62)) { return new View_SaraSelectorComponent2(this.viewUtils,this,62,this._anchor_62,this._vc_62); }
    return (null as any);
  }
  handleEvent_17(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.checkAll(true)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_20(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.checkAll(false)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_52(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.checkAll(false)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/shared/sara-selector/sara-selector.component.ngfactory.ts